import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { GenericInputModule } from '@sla-ng/ui-material';
import { AddRevenueDialogComponent } from './add-revenue-dialog/add-revenue-dialog.component';
import { RevenueDialogComponent } from './revenue-dialog.component';

export * from './revenue-dialog.component';
export * from './add-revenue-dialog/add-revenue-dialog.component';


@NgModule({
    declarations: [ RevenueDialogComponent, AddRevenueDialogComponent ],
    imports: [
        CommonModule,
        MatDialogModule,
        TranslateModule,
        MatProgressBarModule,
        MatTableModule,
        MatIconModule,
        GenericInputModule,
        MatButtonModule,
        MatTooltipModule,
        MatSortModule,
    ],
})
export class RevenueDialogModule {
}
